import cardConstants from '../constants';
import authConstants from '../../auth/constants';

const appendCard = (cards, card) => {
    const newCards = Object.assign({}, cards);
   
    newCards[card.cardData.qrCode] = card;
    newCards[card.qrCode] = card; // this may be the virtual card
    
    return newCards;
};

const appendPass = (passes, pass) => {
    const newPasses = Object.assign({}, passes);
    newPasses[pass.qrCode] = pass;
    return newPasses;
};

const initial = {
    cards: {},
    passes: {},
    showCardholderPage: false,
    showVisitorPassPage: false,
    cardholderPageContext: '',
    currentQrCode: ''
};

// state: key/value map of QRcode to CardData
export function cards(state = initial, action) {
    switch (action.type) {
        case authConstants.SIGN_OUT_SUCCESS:
            return {
                ...initial
            };
        case cardConstants.SHOW_CARDHOLDER_PAGE:
            return {
                ...state,
                showCardholderPage: true,
                showVisitorPassPage: false,
                cardholderPageContext: action.context,
                currentQrCode: action.qrCode
            };
        case cardConstants.HIDE_CARDHOLDER_PAGE:
            return {
                ...state,
                cardholderPageContext: '',
                showCardholderPage: false,
                showVisitorPassPage: false,
                currentQrCode: null
            };
        case cardConstants.SHOW_VISITOR_PASS_PAGE:
            return {
                ...state,
                showCardholderPage: false,
                showVisitorPassPage: true,
                currentQrCode: action.qrCode,
                cardholderPageContext: action.context
            };
        case cardConstants.HIDE_VISITOR_PASS_PAGE:
            return {
                ...state,
                cardholderPageContext: '',
                showCardholderPage: false,
                showVisitorPassPage: false,
                currentQrCode: null
            };
        case cardConstants.GET_CARD_DATA_SUCCESS:
            return {
                ...state,
                cards: {
                    ...appendCard(state.cards || {}, action.data)
                }
            };
        case cardConstants.GET_VISITOR_PASS_SUCCESS:
            return {
                ...state,
                passes: {
                    ...appendPass(state.passes || {}, action.data)
                }
            };
        default:
            return state;
    }
}